import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "on-right text-left" }
const _hoisted_2 = { class: "text-grey-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    class: ["full-width q-py-sm", { 'bg-secondary': _ctx.isActive }],
    align: "left",
    to: _ctx.to
  }, _ctx.$attrs, {
    flat: "",
    "no-caps": ""
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.label), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.description), 1)
      ])
    ]),
    _: 1
  }, 16, ["class", "to"]))
}